import { useState } from "react";
import { useDispatch } from "react-redux";
import searchLogo from '../assets/search.svg'
import { searchQuery } from '../redux/actions/actions';

export default function Search() {
    const[query,setQuery]=useState('');
    const dispatch=useDispatch();
    const debounce=(func,delay)=>{
        let timeoutId;
        if(timeoutId){
            return clearTimeout(timeoutId)
        }
        return function(){
            timeoutId= setTimeout(()=>{
                func();
            },delay);
            
        };
    }
    
    const handleChange=(e)=>{
        setQuery(e.target.value)
    }
    
    const debounceOnChange=(e)=>{
      debounce(()=>handleChange(e),1200)();
    }
    dispatch(searchQuery(query));

    return (
        <div
            className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200"
        >
            <input
                className="outline-none border-none bg-gray-50 h-full w-full mr-2"
                type="search"
                name="search"
                placeholder="Search"
                onChange={debounceOnChange}
            />
            <img
                className="inline h-6 cursor-pointer"
                src={searchLogo}
                alt="Search"
            />
        </div>
    );
}
